/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
// 用户（流量主广告主）id验证(3-7整数)
export function userCheck(rule, value, callback) {
  var reg = /^-?[0-9]{3,7}$/
  if (value == '') {
    callback()
  } else if (!reg.test(value) || value.length > 10) {
    callback(new Error('格式不正确'))
  } else {
    callback()
  }
}
// 0(包含)-1(包含)之间的数字验证
export function oneTwo(rule, value, callback) {
  var reg = /\b(0(\.\d{1,2})?)|1\b/
  if (value == '' || value == null) {
    callback(new Error('必填不能为空'))
  } else if (!reg.test(value)) {
    callback(new Error('格式不正确'))
  } else {
    callback()
  }
}

// 价格正则验证 1-9开头，后跟是0-9，可以跟小数点，但小数点后要带上1-2位小数，类似2,2.0,2.1,2.22等
// 0开头，后可以跟小数点，小数点后要待上1-2位小数，类似0,0.22,0.1等
export function isPrice(rule, value, callback) {
  var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/
  if (value == '' || value == null) {
    callback(new Error('必填不能为空'))
  } else if (!reg.test(value)) {
    callback(new Error('格式不正确'))
  } else {
    callback()
  }
}
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  // const valid_map = ['admin', 'editor']
  // return valid_map.indexOf(str.trim()) >= 0\
  return true
}
export function userIdCheck(rule, value, callback) {
  var reg = /^-?[0-9]{3,7}$/
  if (value == '' || value == null) {
    callback(new Error('必填不能为空'))
  } else if (!reg.test(value) || value.length > 10) {
    callback(new Error('格式不正确'))
  } else {
    callback()
  }
}
// 手机号验证
export function contactPhoneCheck(rule, value, callback) {
  const myreg = /^[1][3,4,5,7,8][0-9]{9}$/
  if (value != '') {
    if (value.length < 1 || value.length > 11) {
      callback(new Error('请输入11位手机号'))
    } else if (value && value.length && !myreg.test(value)) {
      callback(new Error('手机号格式不对'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
// 公司名称校验
export function userNameCheck(rule, value, callback) {
  const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+$/
  if (value != '') {
    if (value.length < 2 || value.length > 50) {
      callback(new Error('请输入2-50位的公司名称'))
    } else if (value && value.length && !reg.test(value)) {
      callback(new Error('请输入合法的公司名称'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
// 联系人校验
export function userContactCheck(rule, value, callback) {
  const reg = /^[\u4e00-\u9fa5_]+$/
  const engReg = /^[a-zA-Z_]+$/
  if (value != '') {
    if (value.length < 2 || value.length > 20) {
      callback(new Error('请输入2-20位的名称'))
    } else if (value && value.length && !reg.test(value) && !engReg.test(value)) {
      callback(new Error('联系人只能输入中文或英文'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
// qq号验证
export function qqNumCheck(rule, value, callback) {
  const reg = /^[1-9][0-9]+$/
  if (value != '') {
    if (value.length < 5 || value.length > 20) {
      callback(new Error('请输入5-20位的qq号'))
    } else if (value && value.length && !reg.test(value)) {
      console.log(1)
      callback(new Error('请输入合法的qq号'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
